import * as actionsType from '@/constants/deviceInfoActionsType';

// Device Info
export function updateDeviceInfo(value) {
  return {
    type: actionsType.UPDATE_DEVICE_INFO,
    value,
  };
}
export function updateDeviceSerialNumber(value) {
  return {
    type: actionsType.DEVICE_SERIAL_NUMBER,
    value,
  };
}
export function updateFirmwareName(value) {
  return {
    type: actionsType.FIRMWARE_NAME,
    value,
  };
}
export function updateFirmwareVersion(value) {
  return {
    type: actionsType.FIRMWARE_VERSION,
    value,
  };
}
export function updateSoftwareName(value) {
  return {
    type: actionsType.SOFTWARE_NAME,
    value,
  };
}
export function updateSoftwareVersion(value) {
  return {
    type: actionsType.SOFTWARE_VERSION,
    value,
  };
}
export function updateBuildDate(value) {
  return {
    type: actionsType.BUILD_DATE,
    value,
  };
}
export function updateHostName(value) {
  return {
    type: actionsType.HOST_NAME,
    value,
  };
}
export function updateIpAddress(value) {
  return {
    type: actionsType.IP_ADDRESS,
    value,
  };
}

// License
export function updateInitialLicenseInfo(value) {
  return {
    type: actionsType.UPDATE_INITIAL_LICENSE_INFO,
    value,
  };
}
export function updateLicenseInfo(value) {
  return {
    type: actionsType.UPDATE_LICENSE_INFO,
    value,
  };
}
export function updateLicenseStatus(value) {
  return {
    type: actionsType.LICENSE_STATUS,
    value,
  };
}
export function updateLicenseType(value) {
  return {
    type: actionsType.LICENSE_TYPE,
    value,
  };
}
export function updateLicenseModifiedDate(value) {
  return {
    type: actionsType.LICENSE_MODIFIED_DATE,
    value,
  };
}
export function updateLicenseExpiredDate(value) {
  return {
    type: actionsType.LICENSE_EXPIRED_DATE,
    value,
  };
}
export function updateClientID(value) {
  return {
    type: actionsType.CLIENT_ID,
    value,
  };
}

export function updateLicenseActivationMode(value) {
  return {
    type: actionsType.LICENSE_ACTIVATION_MODE,
    value,
  };
}
export function updateLicenseTrialAvailable(value) {
  return {
    type: actionsType.LICENSE_TRIAL_AVAILABLE,
    value,
  };
}
export function licenseDayLeft(value) {
  return {
    type: actionsType.LICENSE_DAY_LEFT,
    value,
  };
}
export function licenseDayLeftCheckDate(value) {
  return {
    type: actionsType.LICENSE_DAY_LEFT_CHECK_DATE,
    value,
  };
}
export function licenseDayLeftAlertAvailable(value) {
  return {
    type: actionsType.LICENSE_DAY_LEFT_ALERT_AVAILABLE,
    value,
  };
}

export function setDeviceProperties(value) {
  return {
    type: actionsType.SET_DEVICE_PROPERTIES,
    value,
  };
}

export function resetDeviceProperties() {
  return {
    type: actionsType.RESET_DEVICE_PROPERTIES,
  };
}

export function setDevicePropertyName(value, withOrigin = false) {
  return {
    type: actionsType.SET_DEVICE_PROPERTY_NAME,
    value,
    withOrigin,
  };
}
export function setDeviceNameInStore(value) {
  return {
    type: actionsType.SET_DEVICE_NAME,
    value,
  };
}
export function setHardwareProperties(value) {
  return {
    type: actionsType.SET_HARDWARE_PROPERTIES,
    value,
  };
}
export function setAutoTimezone(value) {
  return {
    type: actionsType.SET_AUTO_TIMEZONE,
    value,
  };
}
export function setAutoDatetime(value) {
  return {
    type: actionsType.SET_AUTO_DATETIME,
    value,
  };
}
export function setOriginAutoTimezone(value) {
  return {
    type: actionsType.SET_ORIGIN_AUTO_TIMEZONE,
    value,
  };
}
export function setOriginAutoDatetime(value) {
  return {
    type: actionsType.SET_ORIGIN_AUTO_DATETIME,
    value,
  };
}
export function setTimezoneFromServer(value) {
  return {
    type: actionsType.SET_TIMEZONE_FROM_SERVER,
    value,
  };
}
export function setDeviceDatetime(value) {
  return {
    type: actionsType.SET_DEVICE_DATETIME,
    value,
  };
}
